import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AddOutlined, Close, EditOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { validatePermission } from 'helpers/authentication';
import { errorAlert, confirmAlert } from 'helpers/alerts';
import { BackButton, CustomButton, TableData } from "components";
import { setBackupCodesProvider, setBackupCodeSelected } from 'redux/slices/admin/providerSlice';
import { getProviderBackupCodesService, deleteProviderBackupCodeService } from 'services/admin/providerService';
import { Box, Grid } from '@mui/material';

function ErrorCodesRespaldoScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [update, setUpdate] = useState(0);
  const { current, backupCodesProvider } = useSelector(store => store.providers)

  useEffect(() => {
    getProviderBackupCodesService(current.host)
      .then(response => dispatch(setBackupCodesProvider(response)))
      .catch(error => errorAlert(error));
  }, [update]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      // position={'absolute'}
      // width={'auto'}
      >
        <div>
          <BackButton click={() => navigate('../..')} />
        </div>
        <div className="container-title">
          <div className="title">Proveedor</div>
          <div className="subtitle">{current.container_name}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Box mt={-5}>
        <TableData
          dataRows={backupCodesProvider}
          headerButtons={[
            validatePermission('proveedores', 'proveedores', ['agregar']) &&
            <CustomButton
              dark={true}
              icon={<AddOutlined />}
              key="addProviderCred"
              name={"Nuevo Código"}
              click={() => navigate("create")}
            />,
          ]}
          dataTitle={[
            "Código",
          ]}
          formatter={({ code }) => ([
            code,
          ])}
          actions={[
            validatePermission('proveedores', 'productos', ['editar']) &&
            {
              label: "Editar",
              icon: <EditOutlined />,
              onClick: (data) => {
                dispatch(setBackupCodeSelected(data));
                navigate("edit");
              },
            },
            validatePermission('proveedores', 'productos', ['editar']) &&
            {
              label: "Eliminar",
              icon: <Close />,
              onClick: ({ code, id }) => {
                confirmAlert({
                  title: "Estás seguro que deseas eliminar este código?",
                  text: ` Código: ${code} será eliminada.`,
                  onConfirm: async () => {
                    deleteProviderBackupCodeService(current.host, id)
                      .then(() => setUpdate(update + 1))
                      .catch(error => errorAlert(error));
                  }
                })
              },
            },
          ]}
        />
      </Box>
    </>
  );
}


export default ErrorCodesRespaldoScreen;